import { Box, Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import type { DashboardSection } from '../../../types';
import { CardGrid } from './CardGrid';

export const BandsSection = ({ section }: { section: DashboardSection }) => (
  <Flex direction="column" gap="20px">
    {(section.bands ?? []).map((b) => (
      <Box key={b.name}>
        <Text variant="overhead" style={{ display: 'block', marginBottom: 10 }}>
          {b.name}
        </Text>
        {b.note && (
          <Text
            variant="small"
            className="text-[12px] text-secondary-400"
            style={{ display: 'block', marginBottom: 10 }}
          >
            {b.note}
          </Text>
        )}
        <CardGrid cards={b.cards} />
      </Box>
    ))}
  </Flex>
);
